import React, { useEffect } from 'react';

import { track } from '@betterment/js-runtime';
import { Icon, Text } from '@betterment/samba-react';
import { Box, Flex, Heading, ListRowButton } from '@betterment/style-closet-react';

import { DirectDepositStepProps } from './data';
import { useTitleDispatch } from './utils';

import CopyableNumber from '../../../Shared/components/CopyableNumber';
import { Account } from '../../data';

interface Props extends DirectDepositStepProps {
  account: Account;
}

export const Overview: React.FC<React.PropsWithChildren<Props>> = ({ goToNextStep, account }) => {
  const setTitle = useTitleDispatch();
  useEffect(() => setTitle('Set up direct deposit'), [setTitle]);
  return (
    <>
      <Box mb="6">
        <Icon name="DepositCheck" size="large" />
      </Box>
      <Flex justifyContent="left" mb="1">
        <Heading variant="primary">Set up direct deposit</Heading>
      </Flex>
      <Box borderBottom="1px solid" borderColor="bmtGrey20" my="8" pb="8">
        <Text as="p">Copy your account information below or download a form to share with your employer.</Text>
      </Box>
      <Box px={[0, 6]} borderBottom="1px solid" borderColor="bmtGrey20" my="6" pb="6">
        <CopyableNumber
          label="Routing number"
          value={account.routingNumber}
          trackingProperties={{ name: 'CopyRoutingNumber', module: 'SetupDirectDeposit' }}
          title="copy routing number"
        />
      </Box>
      <Box px={[0, 6]} borderBottom="1px solid" borderColor="bmtGrey20" mt="6" pb="6">
        <CopyableNumber
          label="Account number"
          value={account.accountNumber}
          trackingProperties={{ name: 'CopyAccountNumber', module: 'SetupDirectDeposit' }}
          title="copy account number"
        />
      </Box>
      <Box borderBottom="1px solid" borderColor="bmtGrey20">
        <ListRowButton
          variant="expanded"
          verticalAlign="top"
          leadingTitle="Download your pre-filled form"
          trailingIcon={<Icon name="CaretRight" size="small" />}
          onPress={() => {
            track('ElementClicked', { name: 'GetDirectDepositForm' });
            goToNextStep();
          }}
        />
      </Box>
    </>
  );
};
